export default __webpack_public_path__ + "static/media/img-plugin-plus.a9f68153.svg";